unable to read source [project]/node_modules/stripe/src/resources/Checkout/index.ts